import React from 'react'
import { AppLink } from 'components/Utility/AppLink/AppLink'

type ImageLoaderProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src?: string | null,
  /** Class of the wrapping div; imageClassName goes on the img */
  className?: string,
  imageClassName?: string,
  /** With manual, the image loads only once ready is true (used by sliders) */
  manual?: boolean,
  ready?: boolean,
  link?: string,
}

/** A lazily loaded image in a wrapper div, optionally linked */
export const ImageLoader: React.FC<ImageLoaderProps> = (props) => {
  const { src, alt, title, onClick, className, imageClassName, manual, ready, link, ...rest } = props
  const isServer = typeof window === 'undefined'

  if (!src && !isServer) {
    return <div className={className}>
      <div className={'empty-image'} onClick={onClick} />
    </div>
  }

  let imageSrc: string | undefined = src ?? undefined
  if (manual && !ready) {
    imageSrc = undefined
  }

  const image = (
    <img
      src={imageSrc}
      loading={manual ? undefined : 'lazy'}
      alt={alt}
      title={title}
      {...rest}
      className={imageClassName}
      onClick={isServer ? undefined : onClick}
    />
  )

  return (
    <div className={className}>
      {link ? <AppLink path={link}>{image}</AppLink> : image}
    </div>
  )
}
